import clsx from 'clsx';
import { FunctionComponent, useMemo } from 'react';

import { isVideo } from '@vestico/utils';

import { ClientImageSourceSet, CropHint } from '@vestico/model';

import { useImageBorderStyles } from '../hooks';
import { BorderRadiusStyles } from '../model/styles';
import { ImageDisplayBlur } from './ImageDisplayBlur';
import { ImageViewerMobile } from './ImageViewerMobile';
import style from './MediaViewerMobile.module.css';

export interface ImageViewerProps {
  url: string;
  srcSet: ClientImageSourceSet;
  thumbURL?: string;
  mimeType: string;
  onLoad?: () => void;
  onZoomStart?: () => void;
  onZoomEnd?: () => void;
  enableZoom?: boolean;
  borderRadius?: BorderRadiusStyles;
  backgroundColor?: string;
  cropHint?: CropHint;
}

export const MediaViewerMobile: FunctionComponent<ImageViewerProps> = ({
  url,
  srcSet,
  thumbURL,
  mimeType,
  onLoad,
  onZoomStart,
  onZoomEnd,
  enableZoom,
  borderRadius,
  backgroundColor,
  cropHint,
}) => {
  const borderStyles = useImageBorderStyles(borderRadius);

  const containerStyle = useMemo(() => {
    const styles = borderStyles;
    styles.backgroundColor = backgroundColor;
    return styles;
  }, [borderStyles, backgroundColor]);

  const isVideoMedia = useMemo(() => isVideo(mimeType), [mimeType]);

  return (
    <div className={clsx(style.imageContainer)} style={containerStyle}>
      {isVideoMedia ? (
        <ImageDisplayBlur coverURL={thumbURL} cropHint={cropHint} />
      ) : (
        <ImageViewerMobile
          url={url}
          srcSet={srcSet}
          thumbURL={thumbURL}
          onLoad={onLoad}
          onZoomStart={onZoomStart}
          onZoomEnd={onZoomEnd}
          enableZoom={!!enableZoom}
          cropHint={cropHint}
        />
      )}
    </div>
  );
};
